import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: routes.LOGIN,
    name: 'LOGIN',
    component: () => import('./LoginPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    path: routes.VERIFY_OTP,
    name: 'VERIFY_OTP',
    component: () => import('./VerifyOtpPage.vue'),
    meta: { requiresGuest: true },
  },
  {
    // No guard: this is a transient processing page reached on return from UAE
    // Pass. It must run for BOTH guests (login / sign-up) and authenticated
    // users (enable UAE Pass from Account Settings). A `requiresGuest` here
    // would bounce a logged-in user to the dashboard before the callback can
    // exchange the code, silently breaking the enable-from-settings flow.
    path: routes.UAE_PASS_CALLBACK,
    name: 'UAE_PASS_CALLBACK',
    component: () => import('./UaePassCallbackPage.vue'),
  },
]
